import React from "react";
import HeaderContainer from "../../components/header/HeaderContainer";
import HeaderTitle from "../../components/header/HeaderTitle";
import HeaderContent from "../../components/header/HeaderContent";
import COLOR from "../../global/Color";
import HeaderContentSmall from "../../components/header/HeaderContentSmall";
import FullImage from "../../components/inner/venderProduct/FullImage";
import SubHeading from "../../components/inner/venderProduct/SubHeading";

import GoodixImage01 from "../../assets/vendorProduct/GoodixImage01.png";
import TableImage01 from "../../assets/vendorProduct/GoodixTable01.png";
import TableImage02 from "../../assets/vendorProduct/GoodixTable02.png";
import TableImage03 from "../../assets/vendorProduct/GoodixTable03.png";
import TableImage04 from "../../assets/vendorProduct/GoodixTable04.png";
import TableImage05 from "../../assets/vendorProduct/GoodixTable05.png";
import TableImage06 from "../../assets/vendorProduct/GoodixTable06.png";
import GoodixTable from "../../components/inner/venderProduct/GoodixTable";
import GoodixTableBox from "../../components/inner/venderProduct/GoodixTableBox";
import { useLanguage } from "../../context/LanguageContext";
import { siteCopy } from "../../i18n/landingCopy";

const Goodix = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.vendor?.goodix || siteCopy.en.pages.vendor.goodix;
  const tableImageMap = [TableImage02, TableImage01, TableImage03, TableImage04, TableImage05, TableImage06];
  const tableBoxes = (copy.tableBoxes || []).map((item, index) => ({
    image: tableImageMap[index],
    title: item.title,
    text: item.text,
  }));

  const renderLines = (lines = []) =>
    lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <>
      <HeaderContainer>
        <HeaderTitle>{copy.title}</HeaderTitle>
        <HeaderContent>
          <span style={{ color: COLOR.MAGORELLEBLUE, fontWeight: 700 }}>
            {copy.title}
            <span style={{ color: COLOR.BLACK, fontWeight: 300, display: "inline-block" }}></span>
          </span>(
          <a
            style={{ textDecoration: "underline", color: COLOR.BLACK }}
            href={copy.website}
            target="_blank"
          >
            {copy.website}
          </a>
          ) {renderLines(copy.headerIntro)}
        </HeaderContent>

        <HeaderContentSmall>{renderLines(copy.bodyParagraphs)}</HeaderContentSmall>

        <FullImage Item={GoodixImage01} />

        <SubHeading>{copy.sections.fingerprintHeading}</SubHeading>

        <HeaderContentSmall>{renderLines(copy.fingerprintIntro)}</HeaderContentSmall>

        {tableBoxes[0] && <GoodixTableBox data={[tableBoxes[0]]} />}
        <GoodixTable
          HeaderData={copy.ultrasonicFingerprintHeader}
          RowData={copy.ultrasonicFingerprintRows}
        />
        {tableBoxes[1] && <GoodixTableBox data={[tableBoxes[1]]} />}
        <GoodixTable
          HeaderData={copy.opticalInDisplayHeader}
          RowData={copy.opticalInDisplayRows}
        />
        {tableBoxes[2] && <GoodixTableBox data={[tableBoxes[2]]} />}
        <GoodixTable
          HeaderData={copy.capacitiveHeader}
          RowData={copy.capacitiveRows}
        />

        <div style={{ height: "1%" }}></div>

        <SubHeading>{copy.sections.touchHeading}</SubHeading>

        <HeaderContentSmall>{renderLines(copy.touchIntro)}</HeaderContentSmall>

        {tableBoxes[3] && <GoodixTableBox data={[tableBoxes[3]]} />}
        <GoodixTable
          HeaderData={copy.touchScreenHeader}
          RowData={copy.touchScreenRows}
        />
        {tableBoxes[4] && <GoodixTableBox data={[tableBoxes[4]]} />}
        <GoodixTable HeaderData={copy.touchPedHeader} RowData={copy.touchPedRows} />
        {tableBoxes[5] && <GoodixTableBox data={[tableBoxes[5]]} />}
        <GoodixTable
          HeaderData={copy.activeStylusHeader}
          RowData={copy.activeStylusRows}
        />

        <div style={{ height: "80px" }} />
      </HeaderContainer>
    </>
  );
};

export default Goodix;
